import { Component, inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Cart } from 'src/app/interfaces/common/cart';
import { CartService } from 'src/app/services/common/cart.service';
import { ReloadService } from 'src/app/services/core/reload.service';
import { UiService } from 'src/app/services/core/ui.service';
import { DATABASE_KEY } from '../../../../core/utils/global-variable';
import { Product } from '../../../../interfaces/common/product';
import { UserService } from '../../../../services/common/user.service';
import { PricePipe } from '../../../pipes/price.pipe';
import { ShippingCharge } from "../../../../interfaces/common/shipping-charge.interface";
import { ShippingChargeService } from "../../../../services/common/shipping-charge.service";
import { OrderOffer } from "../../../../interfaces/common/order-offer.interface";
import { OrderOfferService } from "../../../../services/common/order-offer.service";
import { DiscountTypeEnum } from '../../../../enum/product.enum';
import { DataLayerService } from '../../../../services/core/data-layer.service';
import { UserDataService } from '../../../../services/common/user-data.service';
import { Address } from '../../../../interfaces/common/address.interface';

@Component({
  selector: 'app-cart-slide',
  templateUrl: './cart-slide.component.html',
  styleUrls: ['./cart-slide.component.scss'],
  providers: [PricePipe]
})
export class CartSlideComponent implements OnInit, OnChanges, OnDestroy {

  // Store Data
  cartSlide = false;
  categorySlide = false;
  @Input() carts: Cart[] = [];
  couponDiscount: number = 0;

  // Discount Data
  orderDiscount: number = 0;
  discountTypes: any[] = [];

  //Shipping
  shippingCharge: ShippingCharge;
  orderOffer: OrderOffer;
  selectedAddress: Address = null;

  // Subscriptions
  private subGetData1: Subscription;
  private subGetData2: Subscription;
  private subUpdateData1: Subscription;
  private subDeleteData1: Subscription;

  // Inject
  private readonly router = inject(Router);
  private readonly cartService = inject(CartService);
  private readonly reloadService = inject(ReloadService);
  private readonly uiService = inject(UiService);
  private readonly pricePipe = inject(PricePipe);
  private readonly userService = inject(UserService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly shippingChargeService = inject(ShippingChargeService);
  private readonly orderOfferService = inject(OrderOfferService);
  private readonly dataLayerService = inject(DataLayerService);
  private readonly userDataService = inject(UserDataService);


  ngOnInit(): void {
    // GET DATA FROM PARAM
    this.activatedRoute.queryParamMap.subscribe((res) => {
      if (res.get('cartSlide') !== null) {
        if (res.get('cartSlide') === 'true') {
          this.cartSlide = true;
        } else {
          this.cartSlide = false;
        }
      } else {
        this.cartSlide = false;
      }
    })
    // Base Data
    this.getShippingCharge();

    if (this.userService.getUserStatus()) {
      this.getUserAddress();
    }

    const cData = this.carts

  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.carts && this.carts.length) {
      if (this.userService.getUserStatus()) {
        this.getOrderOfferWithUser();
      } else {
        this.getOrderOffer();
      }
    }
  }

  /**
   * CART FUNCTIONS
   * onIncrementQty()
   * onDecrementQty()
   * onDeleteCartItem()
   * updateCartQty()
   * deleteCartById()
   * onShowCart()
   * onHideCart()
   */
  onIncrementQty(event: MouseEvent, cartId: string, index: number) {
    event.stopPropagation();
    const cart = this.carts?.[index];
    const maxQty = this.getMaxQuantityForCartItem(cart);
    const currentQty = cart?.selectedQty ?? 0;
    if (maxQty != null && currentQty >= maxQty) {
      this.uiService.warn(`শুধুমাত্র ${maxQty} ইউনিট উপলব্ধ`);
      return;
    }
    if (this.userService.getUserStatus()) {
      this.updateCartQty(cartId, { selectedQty: 1, type: 'increment' });
    } else {
      const data = this.cartService.getCartItemFromLocalStorage();
      if (data && data[index] != null) {
        const newQty = data[index].selectedQty + 1;
        if (maxQty != null && newQty > maxQty) {
          this.uiService.warn(`শুধুমাত্র ${maxQty} ইউনিট উপলব্ধ`);
          return;
        }
        data[index].selectedQty = newQty;
        localStorage.setItem(DATABASE_KEY.userCart, JSON.stringify(data));
        this.reloadService.needRefreshCart$(true);
      }
    }
  }

  /** Admin থেকে যে quantity (ওই unit) দেওয়া আছে তার বেশি বাড়ানো যাবে না */
  private getMaxQuantityForCartItem(cart: Cart | null | undefined): number | null {
    if (!cart?.product) return null;
    const product = cart.product as Product;
    if (product.prices?.length && cart.priceId) {
      const priceIdStr = cart.priceId != null ? String(cart.priceId) : '';
      const priceData = product.prices.find((p: any) => {
        const id = p._id ?? p.id;
        return id === cart.priceId || (id != null && String(id) === priceIdStr);
      });
      if (priceData != null && priceData.quantity != null) return Number(priceData.quantity);
    }
    if (product.quantity != null && product.quantity !== undefined) return Number(product.quantity);
    return null;
  }

  onDecrementQty(event: MouseEvent, cartId: string, index: number, cartInput: HTMLInputElement) {
    event.stopPropagation();
    console.log(cartInput.value);
    if (+cartInput.value === 1) {
      this.uiService.warn('Minimum quantity is 0');

    } else {
      if (this.carts[index].selectedQty === 1) {
        this.uiService.warn('Minimum quantity is 0');
        return;
      }
      if (this.userService.getUserStatus()) {
        this.updateCartQty(cartId, { selectedQty: 1, type: 'decrement' });
      } else {
        const data = this.cartService.getCartItemFromLocalStorage();
        if (data != null) {
          data[index].selectedQty = data[index].selectedQty - 1;
          localStorage.setItem(DATABASE_KEY.userCart, JSON.stringify(data));
          this.reloadService.needRefreshCart$(true);
        }
      }
    }
  }

  onDeleteCartItem(cartId?: string, productId?: string, priceId?: string) {
    // Google tag
    // this.removeFromCartGTag(productId);


    if (this.userService.getUserStatus()) {
      this.deleteCartById(cartId)
    } else {
      this.cartService.deleteCartItemFromLocalStorage(productId, priceId);
      this.reloadService.needRefreshCart$();
    }
  }

  private updateCartQty(cartId: string, data: any) {
    this.subUpdateData1 = this.cartService.updateCartQty(cartId, data)
      .subscribe({
        next: ((res) => {
          if (res.type === 'not available') {
            this.uiService.warn(res.message)
          }
          this.reloadService.needRefreshCart$(true);
        }),
        error: (error => {
          console.log(error);
        })
      });
  }

  deleteCartById(cartId: string) {
    this.subDeleteData1 = this.cartService.deleteCartById(cartId)
      .subscribe({
        next: (() => {
          this.reloadService.needRefreshCart$();
        }),
        error: (error => {
          console.log(error);
        })
      });
  }

  onShowCart() {
    this.router.navigate([], { queryParams: { cartSlide: true }, queryParamsHandling: 'merge' })
  }

  onHideCart() {
    this.router.navigate([], { queryParams: { cartSlide: null }, queryParamsHandling: 'merge' })
  }


  /**
   * HTTP HANDLE REQUEST
   * getShippingCharge()
   * getOrderOffer()
   * getOrderOfferWithUser()
   */
  private getShippingCharge() {
    this.subGetData2 = this.shippingChargeService.getShippingCharge()
      .subscribe({
        next: (res => {
          this.shippingCharge = res.data;
        }),
        error: (err => {
          console.log(err);
        })
      });
  }

  private getUserAddress() {
    this.userDataService.getUserAddress()
      .subscribe({
        next: (res) => {
          this.selectedAddress = res.data.find(f => f.setDefaultAddress === true);
          if (!this.selectedAddress && res.data.length > 0) {
            this.selectedAddress = res.data[0];
          }
        },
        error: (err) => {
          console.log(err);
        }
      });
  }

  private getOrderOffer() {
    this.subGetData1 = this.orderOfferService.getOrderOffer().subscribe({
      next: res => {
        if (res) {
          this.orderOffer = res.data;
        }
      },
      error: err => {
        console.log(err);
      }
    });
  }

  private getOrderOfferWithUser() {
    this.subGetData1 = this.orderOfferService.getOrderOfferWithUser()
      .subscribe({
        next: res => {
          this.orderOffer = res.data;
          if (this.orderOffer) {
            if (this.cartSubTotal >= this.orderOffer.amount3OrderMinAmount) {
              if (this.orderOffer.amount3OrderDiscountType === DiscountTypeEnum.PERCENTAGE) {
                this.orderDiscount = (this.orderOffer.amount3OrderDiscountAmount / 100) * this.cartSubTotal;
              } else {
                this.orderDiscount = this.orderOffer.amount3OrderDiscountAmount;
              }
              this.discountTypes = [{
                type: `Cart Amount >= ${this.orderOffer.amount3OrderMinAmount}`,
                amount: this.orderDiscount
              }]
            } else if (this.cartSubTotal >= this.orderOffer.amount2OrderMinAmount) {
              if (this.orderOffer.amount2OrderDiscountType === DiscountTypeEnum.PERCENTAGE) {
                this.orderDiscount = (this.orderOffer.amount2OrderDiscountAmount / 100) * this.cartSubTotal;
              } else {
                this.orderDiscount = this.orderOffer.amount2OrderDiscountAmount;
              }
              this.discountTypes = [{
                type: `Cart Amount >= ${this.orderOffer.amount2OrderMinAmount}`,
                amount: this.orderDiscount
              }]
            } else if (this.cartSubTotal >= this.orderOffer.amountOrderMinAmount) {
              if (this.orderOffer.amountOrderDiscountType === DiscountTypeEnum.PERCENTAGE) {
                this.orderDiscount = (this.orderOffer.amountOrderDiscountAmount / 100) * this.cartSubTotal;
              } else {
                this.orderDiscount = this.orderOffer.amountOrderDiscountAmount;
              }
              this.discountTypes = [{
                type: `Cart Amount Amount >= ${this.orderOffer.amountOrderMinAmount}`,
                amount: this.orderDiscount
              }]

            }

          }


        },
        error: err => {
          console.log(err)
        }
      })
  }

  /**
   * SHOW THE CAPSULE ADD TO CART BUTTON
   * cartToOrderCart()
   */
  cartToOrderCart() {
    this.cartSlide = false;

    if (this.carts.length > 0) {

      if (this.cartSubTotal < this.shippingCharge?.minimumOrderAmount) {
        this.uiService.warn(`Please order at least ${this.shippingCharge?.minimumOrderAmount}৳`);
        this.cartSlide = true;
      } else {
        this.cartSlide = false;
        this.router.navigate(['/', 'checkout']);
        // Google tag
        this.beginCheckoutGTag();
      }
    } else {
      this.uiService.warn('Sorry, No products in your cart');
    }

  }


  // Google tag
  private beginCheckoutGTag() {


    const eventObj = {
      event: "begin_checkout",
      ecommerce: {
        currency: "BDT",
        value: this.grandTotal,
        items: this.carts.map((m, index) => {
          return {
            index: index,
            item_id: (m?.product as Product)?._id,
            product_id: (m?.product as Product)?._id,
            variant_id: m?.priceId,
            item_name: (m?.product as Product)?.name,
            affiliation: "Quick Pharma",
            discount: this.pricePipe.transform((m?.product as Product), 'discountAmount') ?? 0,
            item_brand: (m?.product as Product)?.brand ?? (m?.product as Product)?.brand?.name,
            price: this.pricePipe.transform((m?.product as Product), 'salePrice'),
            quantity: m?.selectedQty
          };
        }),

      }
    }
    this.dataLayerService.eventTrack(eventObj);
  }


  private removeFromCartGTag(cartId: string) {

    const f = this.carts.filter(f => (f?.product as Product)?._id === cartId)

    const eventObj = {
      event: "remove_from_cart",
      ecommerce: {
        currency: "BDT",
        value: this.grandTotal,
        items: f.map((m, index) => {
          return {
            index: index,
            item_id: (m?.product as Product)?._id,
            product_id: (m?.product as Product)?._id,
            variant_id: m?.priceId,
            item_name: (m?.product as Product)?.name,
            affiliation: "Quick Pharma",
            discount: this.pricePipe.transform((m?.product as Product), 'discountAmount') ?? 0,
            item_brand: (m?.product as Product)?.brand ?? (m?.product as Product)?.brand?.name,
            price: this.pricePipe.transform((m?.product as Product), 'salePrice'),
            quantity: m?.selectedQty
          };
        }),

      }
    }
    this.dataLayerService.eventTrack(eventObj);
  }


  /**
   * Calculation
   * cartSubTotal()
   * cartSubTotalWithoutDiscount()
   * grandTotal()
   * cartDiscountAmount()
   */
  get cartSubTotal(): number {
    return this.carts.map(t => {
      return this.pricePipe.transform(t.product as Product, 'salePrice', t.selectedQty) as number;
    }).reduce((acc, value) => acc + value, 0);
  }

  get cartSubTotalWithoutDiscount(): number {
    return this.carts.map(t => {
      return this.pricePipe.transform(t.product as Product, 'regularPrice', t.selectedQty) as number;
    }).reduce((acc, value) => acc + value, 0);
  }

  get grandTotal(): number {
    return (this.cartSubTotalWithoutDiscount - (this.couponDiscount + this.cartDiscountAmount));
  }

  get cartDiscountAmount(): number {

    const cartDiscountAmount = this.carts.map(t => {
      return this.pricePipe.transform(t.product as Product, 'discountAmount', t.selectedQty) as number;
    }).reduce((acc, value) => acc + value, 0);

    return cartDiscountAmount
  }

  onHideCategory() {
    this.categorySlide = false;
  }

  /**
   * On Destroy()
   */
  ngOnDestroy(): void {
    if (this.subGetData1) {
      this.subGetData1.unsubscribe();
    }
    if (this.subGetData2) {
      this.subGetData2.unsubscribe();
    }
    if (this.subUpdateData1) {
      this.subUpdateData1.unsubscribe();
    }
    if (this.subDeleteData1) {
      this.subDeleteData1.unsubscribe();
    }
  }

}
